import script from "./shenpishijuandetail.vue?vue&type=script&setup=true&lang=js"
export * from "./shenpishijuandetail.vue?vue&type=script&setup=true&lang=js"

import "./shenpishijuandetail.vue?vue&type=style&index=0&id=fc4ea5ea&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc4ea5ea"]])

export default __exports__